import { styled } from 'dripsy';
import React from 'react';
import { View } from 'react-native';
import {
  Image as ExpoImage,
  ImageProps as ExpoImageProps,
} from 'expo-image';

import { ImagePlaceholderSvg } from '../svg/ImagePlaceholderSvg';
import { AvatarPlaceholderSvg } from '../svg/AvatarPlaceholderSvg';

export enum PlaceholderTypeEnum {
  Default = 'default',
  Avatar = 'avatar',
}

interface IContainerStyleProps {
  size?: number;
}

const PlaceholderContainer = styled(View)(
  (props: IContainerStyleProps) => ({
    ...(props.size && {
      width: props.size,
      height: props.size,
      padding: props.size * 0.3,
    }),
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '$background20',
  }),
);

export interface IImageProps extends ExpoImageProps {
  size?: number;
  placeholderType?: PlaceholderTypeEnum;
}

export function Image({
  source,
  style,
  size,
  placeholderType,
  ...props
}: IImageProps) {
  const isShowPlaceholder =
    !source ||
    (typeof source === 'object' &&
      !Array.isArray(source) &&
      !source.uri);
  const isAvatarType = placeholderType === PlaceholderTypeEnum.Avatar;

  if (isShowPlaceholder) {
    return (
      // FIXME: fix types
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      <PlaceholderContainer style={style} size={size}>
        {isAvatarType ? (
          <AvatarPlaceholderSvg />
        ) : (
          <ImagePlaceholderSvg />
        )}
      </PlaceholderContainer>
    );
  }

  return <ExpoImage source={source} style={style} {...props} />;
}
